module.exports = __webpack_public_path__ + "static/img/Two_Pair.fe5fd33.svg";